import React, {useState, useEffect, useContext} from 'react';
import VIDABOO_CONSTANTS from '../../../../config/consts';
import scheduleUtils from '../../scheduleUtils';
import moment from 'moment';
import './clientSchedulingInvitationComponent.css';
import ClientBookingOptionRow from '../widget/clientBookingOptionRow';
import DatePickerComponent from '../../datePicker/datePickerComponent';
import TimePickerComponent from '../../datePicker/timePickerComponent';
import TimeZonePicker from '../../datePicker/timeZonePicker';
import SchedulingInWidgetStep3 from '../widget/schedulingInWidgetStep3';
import ButtonComponent from '../../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import LeadCollectorComponent from '../../../widgetComponent/openWidgetComponent/leadCollectorComponent';
import {AppContext} from '../../../../AppModule/Context';
import MLargeViewMeetingStatusComponent from '../../mentorSchedulingComponentsNew/mCalendarRightContainer/components/mCalendarRequestsItemComponent/components/mLargeViewMeetingComponents/mLargeViewMeetingStatusComponent/mLargeViewMeetingStatusComponent';
import AnMentorInfoComponent from '../anonymousPageNew/components/anMentorInfoComponent';
import AnSchedulingMeetingDetailsComponent from '../anonymousPageNew/components/anSchedulingMeetingDetailsComponent';
import PersonalPageMentorInfo from '../../../personalPageComponent/personalPageMentorInfo';
import SessionPriceComponent from '../../../common/genericComponents/sessionPriceComponent/sessionPriceComponent';

const TIME_STEP_MINUTES = 30;

const ClientSchedulingInvitationComponent = (props) => {
  const context = useContext(AppContext);
  const [firstAvailableTimeSlot, setfirstAvailableTimeSlot] = useState(null);
  // const [startCheckPhoneNumber, setStartCheckPhoneNumber] = useState(false);
  const [bookingOptionIndex, setBookingOptionIndex] = useState(0);
  const [bookingRowIndForEditDelete, setBookingRowIndForEditDelete] =
    useState(-1);
  const [showDatePicker, setShowDatePicker] = useState(true);
  const [minDate, setMinDate] = useState(moment());
  // Case 1: registered user (mentor or client) that is logged in:
  // 1.1 currentUser.userId exists.
  // Case 2: Non-registered user (guest). In this case, user arrived with magic-link.
  useEffect(() => {
    updateMinDate();
  }, []);
  useEffect(() => {
    if (props.shouldRestartSchedulingFlow) {
      props.setShouldRestartSchedulingFlow(false);
      moveSchedulingStep(0, false);
    }
  }, [props.shouldRestartSchedulingFlow]);

  const updateMinDate = () => {
    const minDate = scheduleUtils.getMinDate(
      props.extendedMentorDto.mentorDto.scheduleSettingsDto
        .minTimeBeforeBooking,
      props.selectedTimezone,
    );
    setMinDate(minDate);
  };
  const setBookingOptionDate = (date) => {
    console.debug('props.bookingOptions', props.bookingOptions);
    const bookingOption = props.bookingOptions[bookingOptionIndex];
    const rangeStartTimeSender = moment(bookingOption.rangeStartTimeSender)
      .tz(props.selectedTimezone)
      .set({
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate(),
      });
    bookingOption.rangeStartTimeSender = rangeStartTimeSender.valueOf();
    props.updateBookingOptionForDate(bookingOptionIndex, bookingOption);
    // setBookingOptionIndex(-1);
  };
  const setBookingOptionTime = (date) => {
    const bookingOption = props.bookingOptions[bookingOptionIndex];
    const rangeStartTimeSender = moment(bookingOption.rangeStartTimeSender)
      .tz(props.selectedTimezone)
      .startOf('day')
      .add({
        hour: date.getHours(),
        minutes: date.getMinutes(),
      });
    bookingOption.rangeStartTimeSender = rangeStartTimeSender.valueOf();
    props.updateBookingOption(bookingOptionIndex, bookingOption);
    // setBookingOptionIndex(-1);
  };

  const popupDatePicker = (index) => {
    setBookingRowIndForEditDelete(-1);
    setShowDatePicker(true);
    setBookingOptionIndex(index);
  };
  const closePickers = () => {
    setShowDatePicker(false);
  };

  const selectTimeZone = (event) => {
    const selectedTimezone = event.target.value;

    // const selectedTimeZone = selected.utc[0];
    props.setSelectedTimezone(selectedTimezone);
  };
  const validTimeRanges =
    props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
      .availableTimeRangesSelector ===
    VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
      ? props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
          .availableTimeRanges || []
      : props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
            .availableTimeRangesSelector ===
          VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.NO_TIME
        ? []
        : null;

  const validDateRanges =
    props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
      .availableTimeRangesSelector ===
    VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
      ? props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
          .availableTimeRanges || {}
      : props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
            .availableTimeRangesSelector ===
          VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.NO_TIME
        ? {}
        : null;
  const onMonthChange = (date) => {
    const startOfMonthDate = moment
      .tz(date, 'MMM YYYY', props.selectedTimezone)
      .startOf('month')
      .startOf('day')
      .valueOf();
    if (
      props.extendedMentorDto.mentorDto.scheduleSettingsDto.autoMentorApproval
    ) {
      const currentMonthStartDate = moment()
        .tz(props.selectedTimezone)
        .startOf('month')
        .startOf('day')
        .valueOf();
      // Parse the date string and ensure it's in the selected timezone

      if (currentMonthStartDate <= startOfMonthDate) {
        const endOfMonthDate = moment
          .tz(date, 'MMM YYYY', props.selectedTimezone)
          .endOf('month')
          .endOf('day')
          .valueOf();
        props.setAlreadyBookedTimeRanges(startOfMonthDate, endOfMonthDate);
      } else if (props.generateMentorAvailabilityListForMonth) {
        props.generateMentorAvailabilityListForMonth(
          startOfMonthDate,
          false,
          true,
        );
      }
    } else {
      props.generateMentorAvailabilityListForMonth(
        startOfMonthDate,
        false,
        true,
      );
    }
  };

  const moveSchedulingStep = (nextStep, finishedStep1) => {
    props.setShowSuccessComponent(false);
    setShowDatePicker(true);
    setBookingRowIndForEditDelete(-1);
    setBookingOptionIndex(0);
    props.moveSchedulingStep(nextStep, finishedStep1);
    updateMinDate();
  };

  return (
    <div className="et-client-scheduling-invitation-wrap">
      <div className="et-client-scheduling-main-wrap">
        <div className="et-profile-booking-options-wrap">
          {props.showSuccessComponent ? (
            <>
              <AnSchedulingMeetingDetailsComponent
                bfiDto={props.newBfiDto}
                currentUserId={props.currentUserId}
                editableTitle={props.newBfiDto.title}
                editableNotes={props.newBfiDto.notes}
                extendedMentorDto={props.extendedMentorDto}
                recipients={props.newBfiDto.recipients}
              />
            </>
          ) : (
            <>
              {props.isAnonymousPage ? (
                <AnMentorInfoComponent
                  displayName={props.extendedMentorDto.mentorDto.displayName}
                  sessionTitle={
                    props.extendedMentorDto.sessionTemplateDto?.sessionTitle
                  }
                  userProfileImage={props.extendedMentorDto.photoDto?.photoUrl}
                />
              ) : (
                <PersonalPageMentorInfo
                  extendedMentorDto={props.extendedMentorDto}
                  selectedWidgetAppType={
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
                  }
                />
              )}
              {props.isAnonymousPage && (
                <div className="et-n-csic-profile-separator" />
              )}
              <div className="et-pbow-meeting-text-wrap">
                <div className="et-txt-meeting-details">
                  {props.isAnonymousPage
                    ? 'Meeting Time'
                    : context.languageSet.SCHEDULING.MEETING_DETAILS}
                </div>
                {!props.extendedMentorDto.mentorDto.scheduleSettingsDto
                  ?.autoMentorApproval && (
                  <div className="et-txt-options">
                    {context.languageSet.SCHEDULING.SET_UPTO_THREE_OPTIONS}
                  </div>
                )}
              </div>

              <div className="et-cs-booking-options-wrap">
                {props.bookingOptions?.map((alternative, index) => {
                  return (
                    <React.Fragment key={index}>
                      <ClientBookingOptionRow
                        index={index}
                        isAnonymousPage={props.isAnonymousPage}
                        bookingOptionIndex={bookingOptionIndex}
                        bookingOption={alternative}
                        handleDateClick={popupDatePicker}
                        handleTimeClick={(date) => setBookingOptionTime(date)}
                        handleDelete={(index) => {
                          setBookingRowIndForEditDelete(-1);
                          setBookingOptionIndex(0);
                          props.deleteBookingOption(index);
                        }}
                        showDelete={props.bookingOptions.length > 1}
                        timeFormat={
                          props.extendedMentorDto?.mentorDto
                            ?.scheduleSettingsDto.timeFormat
                        }
                        firstAvailableTimeSlot={firstAvailableTimeSlot}
                        showPrevNextBtn={false}
                        showEditDeleteBtn={
                          props.showSuccessComponent ||
                          (props.extendedMentorDto.mentorDto.scheduleSettingsDto
                            .autoMentorApproval &&
                            showDatePicker)
                            ? false
                            : true
                        }
                        bookingRowIndForEditDelete={bookingRowIndForEditDelete}
                        setBookingRowIndForEditDelete={
                          setBookingRowIndForEditDelete
                        }
                        selectedTimezone={
                          props.selectedTimezone ||
                          scheduleUtils.generateGuessedTimezone()
                        }
                        widgetLanguageLocaleKey={props.widgetLanguageLocaleKey}
                      />
                      {props.bookingOptions.length > 1 &&
                        props.bookingOptions.length - 1 !== index && (
                          <div className="et-or-text">
                            <div className="et-or-text-bar" />
                            {context.languageSet.INFO_COLLECTOR.OR}
                            <div className="et-or-text-bar" />
                          </div>
                        )}
                      {/*
                        <div
                          className={`et-overlay-container ${
                            bookingRowIndForEditDelete === index
                              ? 'et-show-overlay-container'
                              : 'et-hide-overlay-container'
                          }`}
                          onClick={() =>
                            setBookingRowIndForEditDelete(-1)
                          }></div>
                        */}
                    </React.Fragment>
                  );
                })}
              </div>
            </>
          )}
        </div>
        <div className="et-date-time-wrap">
          {props.isAnonymousPage && !props.showSuccessComponent && (
            <MLargeViewMeetingStatusComponent
              hideTooltip={true}
              meetingStatus={'ANONYMOUS'}
              statusText={
                props.isAnonymousPage && props.isNewMeetingFlow
                  ? 'CREATE NEW MEETING'
                  : 'RESCHEDULE MEETING'
              }
            />
          )}
          <>
            {!props.showSuccessComponent ? (
              showDatePicker ? (
                <div className="et-smc-mr-date-wrap">
                  <div className="et-smc-client-date-selectors-wrap">
                    <div className="et-smc-txt-schedule-meeting">
                      {props.extendedMentorDto.mentorDto.appControlDto
                        .widgetEditableTexts[
                        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
                      ] || context.languageSet.SCHEDULING.LETS_SCHEDULE_MEETING}
                      {props.extendedMentorDto.mentorDto.scheduleSettingsDto
                        .autoMentorApproval && (
                        <div className="et-smc-session-price-wrap">
                          <SessionPriceComponent
                            paymentFlowBasedSessionDto={
                              props.paymentFlowBasedSessionDto
                            }
                          />
                        </div>
                      )}
                    </div>
                    <div className="et-smc-txt-select-date-time">
                      {
                        context.languageSet.SCHEDULING
                          .SELECT_MEETING_DATE_AND_TIME
                      }
                    </div>
                    <div className="et-smc-client-date-time-sel-wrap">
                      <div className="et-smc-client-date-sel-wrap">
                        <DatePickerComponent
                          selected={
                            props.bookingOptions[bookingOptionIndex]
                              ?.rangeStartTimeSender
                          }
                          onChange={(date) => setBookingOptionDate(date)}
                          onMonthChange={onMonthChange}
                          inline
                          minDate={minDate}
                          weekStartDay={
                            props.extendedMentorDto.mentorDto
                              .scheduleSettingsDto.weekStartDay
                          }
                          validTimeRanges={validDateRanges}
                          scheduleSettingsDto={
                            props.extendedMentorDto.mentorDto
                              .scheduleSettingsDto
                          }
                          alreadyBookedTimeRanges={
                            props.alreadyBookedTimeRanges
                          }
                          selectedTimezone={
                            props.selectedTimezone ||
                            scheduleUtils.generateGuessedTimezone()
                          }
                          sessionTimeLimit={
                            props.extendedMentorDto.sessionTemplateDto
                              .sessionTimeLimit *
                            60 *
                            1000
                          }
                          isLoading={props.isLoading}
                          widgetLanguageLocaleKey={
                            props.widgetLanguageLocaleKey
                          }
                          availableSlotsListsByDate={
                            props.availableSlotsListsByDate
                          }
                        />
                      </div>
                      <div className="et-smc-client-time-sel-wrap">
                        <TimePickerComponent
                          selected={
                            props.bookingOptions[bookingOptionIndex]
                              ?.rangeStartTimeSender
                          }
                          onChange={(date) => setBookingOptionTime(date)}
                          minDate={minDate}
                          timeIntervals={
                            props.extendedMentorDto.mentorDto
                              .scheduleSettingsDto.startTimeSlotJumps ||
                            TIME_STEP_MINUTES
                          }
                          timeFormat={
                            props.extendedMentorDto.mentorDto
                              .scheduleSettingsDto.timeFormat
                          }
                          sessionTimeLimit={
                            props.extendedMentorDto.sessionTemplateDto
                              .sessionTimeLimit *
                            60 *
                            1000
                          }
                          validTimeRanges={validTimeRanges}
                          alreadyBookedTimeRanges={
                            props.alreadyBookedTimeRanges
                          }
                          firstAvailableTimeSlot={firstAvailableTimeSlot}
                          setfirstAvailableTimeSlot={setfirstAvailableTimeSlot}
                          selectedTimezone={
                            props.selectedTimezone ||
                            scheduleUtils.generateGuessedTimezone()
                          }
                          mentorTimeZone={
                            props.extendedMentorDto?.mentorDto
                              ?.scheduleSettingsDto.timezone
                          }
                          availableSlotsListsByDate={
                            props.availableSlotsListsByDate
                          }
                        />
                      </div>
                    </div>
                    <div className="et-timezone-wrap">
                      {props.selectedTimezone && (
                        <TimeZonePicker
                          selectedTimezone={props.selectedTimezone}
                          selectTimeZone={selectTimeZone}
                          globeColor="var(--et-mentor-cta-btn-primary-background-color-fc)"
                        />
                      )}
                    </div>
                  </div>
                  <div className="et-add-option-schedule-btn-wrap">
                    <div className="et-pp-scheduling-btns-wrap">
                      {!props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
                        .autoMentorApproval &&
                        !(props.bookingOptions.length > 2) && (
                          <div
                            className={`et-smc-add-button  ${
                              props.recipients?.length > 1
                                ? 'et-add-option-schedule-btn-wrap-disabled'
                                : ''
                            }`}>
                            <ButtonComponent
                              type="primary-outlined"
                              text={
                                '+ ' +
                                context.languageSet.SCHEDULING
                                  .ADD_ANOTHER_OPTION
                              }
                              onClick={() => {
                                props.addBookingOption();
                                popupDatePicker(props.bookingOptions.length);
                              }}
                            />
                          </div>
                        )}
                      <div className="et-smc-next-button">
                        <ButtonComponent
                          type="primary"
                          onClick={closePickers}
                          text={context.languageSet.CONSOLTO_WIDGET.SCHEDULE}
                        />
                      </div>
                    </div>
                  </div>
                  {props.recipients?.length > 1 && (
                    <div className="et-smc-multiple-attendees-txt">
                      Multi-option currently not supported together with
                      multiple attendees
                    </div>
                  )}
                </div>
              ) : (
                <div className="et-smc-mr-submit-data-wrap">
                  <div className="et-smc-txt-schedule-meeting">
                    {props.extendedMentorDto.mentorDto.appControlDto
                      .widgetEditableTexts[
                      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
                    ] || context.languageSet.SCHEDULING.LETS_SCHEDULE_MEETING}
                  </div>
                  <LeadCollectorComponent
                    isDemo={props.isDemo}
                    isPersonalPage
                    requesterEmail={props.requesterEmail}
                    callSendMessageFunc={props.callSendMessageFunc}
                    mentor={props.extendedMentorDto}
                    selectedWidgetAppType={
                      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING
                    }
                    callbackSuccessInfoSend={props.submitNewBookingFlowInstance}
                    isBookingFlowRunning={props.isBookingFlowRunning}
                    backBtnTxt={context.languageSet.SCHEDULING.BACK}
                    submitBtnTxt={context.languageSet.CONSOLTO_WIDGET.SCHEDULE}
                    backBtnFunc={() => {
                      setShowDatePicker(true);
                    }}
                    isPersonalSchedulePage={true}
                    getRecipientsListWithAddButtonComp={
                      props.getRecipientsListWithAddButtonComp
                    }
                    areAllEmailsValid={props.areAllEmailsValid}
                    paymentFlowBasedSessionDto={
                      props.paymentFlowBasedSessionDto
                    }
                  />
                </div>
              )
            ) : (
              <div className="et-schedule-final-step-wrap">
                <SchedulingInWidgetStep3
                  isAnonymousPage={props.isAnonymousPage}
                  isAutoApprovalOn={
                    props.extendedMentorDto?.mentorDto?.scheduleSettingsDto
                      .autoMentorApproval
                  }
                  bookingOptions={props.bookingOptions}
                  mentor={props.extendedMentorDto}
                  selectedTimezone={props.selectedTimezone}
                  timeFormat={
                    props.extendedMentorDto.mentorDto.scheduleSettingsDto
                      .timeFormat
                  }
                  moveSchedulingStep={moveSchedulingStep}
                  recreateBookingOption={props.recreateBookingOption}
                  restartSchedulingFlow={props.restartSchedulingFlow}
                />
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default ClientSchedulingInvitationComponent;
